/**
    商品列表
**/
<template>
        <div class="rightaside_content">

          <h3 class="headerTitle">我的订单</h3>
          <el-tabs type="border-card" v-loading='loading' v-model="activeName"  @tab-click="tabhandleClick">
            <el-tab-pane name=0>
                <span slot="label">全部有效订单</span>
                <div class="tab_pane_content">

                    <div class="search_box">
                      <div class="div-left">
                      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" id="one"
                                   @change="handleCheckAllChangeOne"
                      >全选</el-checkbox>
                      </div>
<!--                      <a style="color: red" v-if="isDealer">温馨提示：请尽快完成企业网银的支付和审核！</a>-->
                      <div class="div-right">
                      <el-input placeholder="请输入订单标题/订单号" v-model="allValue" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search" @click="searchHandle(allValue)"></el-button>
                      </el-input>
                      </div>
                    </div>
                  <div  v-for="(item,index) in orderInfoList" :key="index" :class="item.status==1?'orderbox_info redBorder':'orderbox_info'">

                     <div class="orderbox_info_header">
                           <div style="width:80%">
                             <p >
                               <el-checkbox-group v-model="checkedOrderIds" @change="handlecheckedOrderIdChange">
                                 <el-checkbox v-if="item.status==1?true:false"
                                              @change="
                                                    handleCheckedCountryChange(
                                                      index,
                                                      item,
                                                      item.totalOrderNumber,
                                                      item.orderAmount,
                                                      $event
                                                    )"
                                              :key="item.oid"
                                              :label="item.oid"
                                              :class="'checkBoxLable'"

                                 >{{(item.groupStatus&&item.groupStatus!=2)?'拼团中': orderStatus(item.status)}}
                                 </el-checkbox>

                                 <!--                                              :label="(item.groupStatus&&item.groupStatus!=2)?'拼团中': orderStatus(item.status)"-->

                               </el-checkbox-group>
                             </p>
                                <p v-if="item.status!=1?true:false">{{(item.groupStatus&&item.groupStatus!=2)?'拼团中': orderStatus(item.status)}}</p>
                                <p>{{item.commodityName}}</p>
                                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                                <span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider direction="vertical"></el-divider>
                                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                                <br v-if="item.orderRemark!=null"><span class="font-size" v-if="item.orderRemark!=null">订单备注： <i>{{item.orderRemark}}</i></span>
                            </div>
                            <div>
                                <span class="order_money">订单金额：<i >{{item.totalMoney || 0.00}}</i> 元</span>
                            </div>
                           </div>
                        <el-row class="order_goods_whole">
                            <el-col :span="20" @click.native="gotoDetail(item)">
                                <el-row class="order_goods" v-for="(goodsItem,index) in item.bxyCommodityList" :key="index">
                                    <el-col :span="2">
                                        <!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
                                        <el-image :src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`" class="bg"
                                        style="width: 62px; height: 62px"
                                        >
                                            <div slot="error" class="image-slot">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                    </el-col>
                                    <el-col :span="15" class="order_Info_item">
                                        <!-- <p>{{goodsItem.specificationlist[0].attributeContent}}========</p> -->
                                        <p>{{goodsItem.name}}  <span style="color:#78b942">{{goodsItem.specificationlist != null && goodsItem.specificationlist.length>0?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span></p>

                                       <p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
                                        <!-- <p>{{(item.price!=null && item.price!="")?item.price: item.marketprice}} * {{item.number || 1 }}</p> -->
                                    </el-col>

                                </el-row>
                            </el-col>
                            <el-col :span="4">
                                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
                                <el-button v-if="item.status==4&&item.commentStatus!=1" class="buttonStyle dangerBg" type="danger" @click="orderEvaluation(item)">订单评价</el-button>
                                <el-button v-if="item.status==3?true:false" class="buttonStyle dangerBg" type="danger" @click="confirmRceipt(item)">确认收货</el-button>
                                <el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger" @click="payOrderNow(item.amount,item)">立即支付</el-button>
                                <el-button v-if="item.status==35" class="buttonStyle dangerBg" type="danger" @click="paymentVoucher(item)">上传凭证</el-button>
                                <el-button v-if="item.status==34" class="buttonStyle dangerBg" type="danger" @click="paymentVoucher(item)">重传凭证</el-button>
                                <!-- <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button> -->
                                <el-button v-if="item.status==1 || item.status==35" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button>
                                <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(item.oid)">移出订单</el-button>
                                <el-button v-if="item.orderType == 5" class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
                                <el-button class="buttonStyle" plain @click="down(item.oid)">导出订单</el-button>
                            </el-col>
                        </el-row>
                     </div>
                    <div class="noData" v-if="orderInfoList.length==0?true:false">
                             您还没有相关订单。
                    </div>
<!--                  <div  v-if="orderInfoList.length==0?false:true">
                    <el-row >
                      <el-col :span="6">
                      <div > <p class="pOne">合计</p>     </div></el-col>

                      <el-col :span="6">
                      <div class="grid-content totalNum">
                        已选择 <strong>{{ orderNum }}</strong> 订单
                      </div></el-col>

                      <el-col :span="6">
                      <div class="grid-content totalNum">
                        合计金额:<strong class="totalSize">{{orderPrice}}</strong
                      >元
                      </div></el-col>
                      <el-col :span="6">
                        <div class="float:right ">
                        <el-button
                          class="buttonOne"
                          type="danger"
                          size=""
                          @click="submitForm()"
                        >合并支付</el-button>
                      </div></el-col>
                    </el-row>
                  </div>-->

                </div>
            </el-tab-pane>
            <el-tab-pane name="1" label="待支付">
                 <!-- <span slot="label">待支付</span> -->
                 <span slot="label">待支付</span>
                 <div  class="tab_pane_content">
                    <div class="search_box">
                      <div class="div-left">

                        <el-checkbox :indeterminate="isIndeterminateTwo" v-model="checkAllTwo" id="two"
                                     @change="handleCheckAllChangeTwo"
                        >全选</el-checkbox>
                      </div>
<!--                        <a style="color: red" v-if="isDealer">温馨提示：请尽快完成企业网银的支付和审核！</a>-->
                      <div class="div-right">
                      <el-input placeholder="请输入订单标题/订单号" v-model="waitpayValue" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search" @click="searchHandle(waitpayValue)"></el-button>
                        </el-input>
                      </div>
                    </div>
                    <div v-for="(item,index) in orderInfoList" :key="index" :class="item.status==1?'orderbox_info redBorder':'orderbox_info'">

                        <div class="orderbox_info_header">
                           <div style="width:80%">
                                <p >

                                  <el-checkbox-group v-model="checkedOrderIdsTwo" @change="handlecheckedOrderIdTwoChange">
                                    <el-checkbox v-if="item.status==1?true:false" v-model="item.check"
                                                 @change="
                                                    handleCheckedCountryChange(
                                                      index,
                                                      item,
                                                      item.totalOrderNumber,
                                                      item.orderAmount,
                                                      $event
                                                    )"
                                                 :key="item.oid"
                                                 :label="item.oid"
                                                 :class="'checkBoxLable'"

                                    >{{(item.groupStatus&&item.groupStatus!=2)?'拼团中': orderStatus(item.status)}}
                                    </el-checkbox>
                                    <!--                                              :label="(item.groupStatus&&item.groupStatus!=2)?'拼团中': orderStatus(item.status)"-->
                                  </el-checkbox-group>

                                </p>
                                <p>{{item.commodityName}}</p>
                                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                                <span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider direction="vertical"></el-divider>
                                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                             <br v-if="item.orderRemark!=null"><span class="font-size" v-if="item.orderRemark!=null">订单备注： <i>{{item.orderRemark}}</i></span>
                            </div>
                            <div>
                                <span class="order_money">订单金额：<i >{{item.totalMoney || 0.00}}</i> 元</span>
                            </div>
                        </div>
                        <el-row class="order_goods_whole">
                            <el-col :span="20" @click.native="gotoDetail(item)">
                                <el-row class="order_goods"  v-for="(goodsItem,index) in item.bxyCommodityList" :key="index">
                                    <el-col :span="2">
                                        <!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
                                        <el-image :src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
                                            <div slot="error" class="image-slot">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                    </el-col>
                                    <el-col :span="15" class="order_Info_item">
                                        <!-- <p>{{item.proTitle}}</p>{{item.specificationlist[0].name}}-->
                                       <p>{{goodsItem.name}}  <span style="color:#78b942">{{goodsItem.specificationlist!=null && goodsItem.specificationlist.length>0?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span></p>
                                       <p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
                                        <!-- <p>{{(item.price!=null && item.price!="")?item.price: item.marketprice}} * {{item.number || 1 }}</p> -->
                                    </el-col>

                                </el-row>
                            </el-col>
                            <el-col :span="4">
                                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
                                <el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger" @click="payOrderNow(item.amount,item)">立即支付</el-button>
                                <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button>
                                <el-button v-if="item.status==1?true:false" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button>
                                <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(item.oid)">移出订单</el-button>
                                <el-button v-if="item.orderType == 5" class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
                                <el-button class="buttonStyle" plain @click="down(item.oid)">导出订单</el-button>

                            </el-col>
                        </el-row>
                   </div>

                    <div class="noData" v-if="orderInfoList.length==0?true:false">
                             您还没有相关订单。
                    </div>
<!--                   <div  v-if="orderInfoList.length==0?false:true">
                     <el-row >
                       <el-col :span="6">
                         <div > <p class="pOne">合计</p>     </div></el-col>

                       <el-col :span="6">
                         <div class="grid-content totalNum">
                           已选择 <strong>{{ orderNum }}</strong> 订单
                         </div></el-col>

                       <el-col :span="6">
                         <div class="grid-content totalNum">
                           合计金额:<strong class="totalSize">{{orderPrice}}</strong
                         >元
                         </div></el-col>
                       <el-col :span="6">
                         <div class="float:right ">
                           <el-button
                             class="buttonOne"
                             type="danger"
                             size=""
                             @click="submitForm()"
                           >合并支付</el-button>
                         </div></el-col>
                     </el-row>
                   </div>-->
                </div>
            </el-tab-pane>
            <el-tab-pane name=2 label="待发货">
                <span slot="label">待发货</span>
                    <div  class="tab_pane_content">
                        <div class="search_box">
                          <div class="div-left"></div>
                          <div class="div-right">
                            <el-input placeholder="请输入订单标题/订单号" v-model="waitSendValue" class="input-with-select">
                                <el-button slot="append" icon="el-icon-search"  @click="searchHandle(waitSendValue)"></el-button>
                            </el-input>
                          </div>
                        </div>
                         <div v-for="(item,index) in orderInfoList" :key="index" :class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
                                <div class="orderbox_info_header">
                                <div style="width:80%">
                                        <p>{{orderStatus(item.status)}}</p>
                                        <p>{{item.commodityName}}</p>
                                        <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                                        <span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider direction="vertical"></el-divider>
                                        <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                                  <br v-if="item.orderRemark!=null"><span class="font-size" v-if="item.orderRemark!=null">订单备注： <i>{{item.orderRemark}}</i></span>
                                    </div>
                                    <div>
                                        <span class="order_money">订单金额：<i >{{item.totalMoney || 0.00}}</i> 元</span>
                                    </div>
                                </div>
                                <el-row class="order_goods_whole">
                                    <el-col :span="20" @click.native="gotoDetail(item)">
                                        <el-row class="order_goods"  v-for="(goodsItem,index) in item.bxyCommodityList" :key="index">
                                            <el-col :span="2">
                                                <!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
                                                <el-image :src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
                                                    <div slot="error" class="image-slot">
                                                        <i class="el-icon-picture-outline"></i>
                                                    </div>
                                                </el-image>
                                            </el-col>
                                            <el-col :span="15" class="order_Info_item">
                                                <!-- <p>{{item.proTitle}}</p>  {{item.specificationlist[0].name}}-->
                                                <p>{{goodsItem.name}}  <span style="color:#78b942">{{goodsItem.specificationlist!=null && goodsItem.specificationlist.length>0?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span></p>

                                                <p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
                                            </el-col>

                                        </el-row>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
                                        <el-button class="buttonStyle" plain @click="down(item.oid)">导出订单</el-button>
                                        <el-button v-if="item.orderType == 5" class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
                                        <!-- <el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger" @click="payOrderNow(item.amount,item)">立即支付</el-button>
                                        <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button>
                                        <el-button v-if="item.status==5?false:true" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button>
                                        <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(item.oid)">移出订单</el-button> -->

                                    </el-col>
                                </el-row>
                        </div>
                        <div class="noData" v-if="orderInfoList.length==0?true:false">
                                您还没有相关订单。
                        </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name=3 label="待收货">
                <span slot="label">待收货</span>
                <div  class="tab_pane_content">
                    <div class="search_box">
                      <div class="div-left"></div>
                      <div class="div-right">
                        <el-input placeholder="请输入订单标题/订单号" v-model="waitGetValue" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search"  @click="searchHandle(waitGetValue)"></el-button>
                        </el-input>
                        </div>
                    </div>
                    <div v-for="(item,index) in orderInfoList" :key="index" :class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
                        <div class="orderbox_info_header">
                           <div style="width:80%">
                                <p>{{orderStatus(item.status)}}</p>
                                <p>{{item.commodityName}}</p>
                                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                                <span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider direction="vertical"></el-divider>
                                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                             <br v-if="item.orderRemark!=null"><span class="font-size" v-if="item.orderRemark!=null">订单备注： <i>{{item.orderRemark}}</i></span>
                            </div>
                            <div>
                                <span class="order_money">订单金额：<i >{{item.totalMoney || 0.00}}</i> 元</span>
                            </div>
                        </div>
                        <el-row class="order_goods_whole">
                            <el-col :span="20" @click.native="gotoDetail(item)">
                                <el-row class="order_goods" v-for="(goodsItem,index) in item.bxyCommodityList" :key="index">
                                    <el-col :span="2">
                                        <!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
                                        <el-image :src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
                                            <div slot="error" class="image-slot">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                    </el-col>
                                    <el-col :span="15" class="order_Info_item">
                                        <!-- <p>{{item.proTitle}}</p> {{item.specificationlist[0].name}}-->
                                        <p>{{goodsItem.name}}  <span style="color:#78b942">{{goodsItem.specificationlist!=null && goodsItem.specificationlist.length>0?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span></p>
                                        <p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
                                    </el-col>

                                </el-row>
                            </el-col>
                            <el-col :span="4">
                                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
                                <el-button v-if="item.status==3?true:false" class="buttonStyle dangerBg" type="danger" @click="confirmRceipt(item)">确认收货</el-button>
                                <el-button class="buttonStyle" plain @click="down(item.oid)">导出订单</el-button>
                                <el-button v-if="item.orderType == 5" class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
                                <!-- <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button>
                                <el-button v-if="item.status==5?false:true" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button>
                                <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(item.oid)">移出订单</el-button> -->

                            </el-col>
                        </el-row>
                   </div>
                     <div class="noData" v-if="orderInfoList.length==0?true:false">
                             您还没有相关订单。
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name=4 label="已完成">
                <span slot="label">已完成</span>
                <div  class="tab_pane_content">
                    <div class="search_box">
                      <div class="div-left"></div>
                      <div class="div-right">
                        <el-input placeholder="请输入订单标题/订单号" v-model="finishiValue" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search"  @click="searchHandle(finishiValue)"></el-button>
                        </el-input>
                        </div>
                    </div>
                    <div v-for="(item,index) in orderInfoList" :key="index" :class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
                        <div class="orderbox_info_header">
                           <div style="width:80%">
                                <p>{{orderStatus(item.status)}}</p>
                                <p>{{item.commodityName}}</p>
                                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                                <span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider direction="vertical"></el-divider>
                                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                             <br v-if="item.orderRemark!=null"><span class="font-size" v-if="item.orderRemark!=null">订单备注： <i>{{item.orderRemark}}</i></span>
                            </div>
                            <div>
                                <span class="order_money">订单金额：<i >{{item.totalMoney || 0.00}}</i> 元</span>
                            </div>
                        </div>
                        <el-row class="order_goods_whole">
                            <el-col :span="20" @click.native="gotoDetail(item)">
                                <el-row class="order_goods" v-for="(goodsItem,index) in item.bxyCommodityList" :key="index">
                                    <el-col :span="2">
                                        <!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
                                        <el-image :src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
                                            <div slot="error" class="image-slot">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                    </el-col>
                                    <el-col :span="15" class="order_Info_item">
                                        <!-- <p>{{item.proTitle}}</p> {{item.specificationlist[0].name}}-->
                                        <p>{{goodsItem.name}}  <span style="color:#78b942">{{goodsItem.specificationlist!=null && goodsItem.specificationlist.length>0?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span></p>
                                       <p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
                                    </el-col>

                                </el-row>
                            </el-col>
                            <el-col :span="4">
                                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
                                <el-button v-if="item.status==4&&item.commentStatus!=1" class="buttonStyle dangerBg" type="danger" @click="orderEvaluation(item)">订单评价</el-button>
                                <el-button class="buttonStyle" plain @click="down(item.oid)">导出订单</el-button>
                                <el-button v-if="item.orderType == 5" class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
                                 <!-- <el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger" @click="payOrderNow(item.amount,item)">立即支付</el-button>
                                <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button>
                                <el-button v-if="item.status==5?false:true" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button>
                                <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(item.oid)">移出订单</el-button> -->

                            </el-col>
                        </el-row>
                   </div>
                    <div class="noData" v-if="orderInfoList.length==0?true:false">
                                您还没有相关订单。
                    </div>
                </div>
                </el-tab-pane>
            <el-tab-pane name=5 label="已关闭">
                <span slot="label">已关闭</span>
                <div class="tab_pane_content">
                    <div class="search_box">
                      <div class="div-left"></div>
                      <div class="div-right">
                        <el-input placeholder="请输入订单标题/订单号" v-model="closeValue" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search" @click="searchHandle(closeValue)"></el-button>
                        </el-input>
                        </div>
                    </div>
                    <div v-for="(item,index) in orderInfoList" :key="index" :class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
                        <div class="orderbox_info_header">
                           <div style="width:80%">
                                <p>{{orderStatus(item.status)}}</p>
                                <p>{{item.commodityName}}</p>
                                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                                <span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider direction="vertical"></el-divider>
                                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                             <br v-if="item.orderRemark!=null"><span class="font-size" v-if="item.orderRemark!=null">订单备注： <i>{{item.orderRemark}}</i></span>
                            </div>
                            <div>
                                <span class="order_money">订单金额：<i >{{item.totalMoney || 0.00}}</i> 元</span>
                            </div>
                        </div>
                        <el-row class="order_goods_whole">
                            <el-col :span="20" @click.native="gotoDetail(item)">
                                <el-row class="order_goods" v-for="(goodsItem,index) in item.bxyCommodityList" :key="index">
                                    <el-col :span="2">
                                        <!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
                                        <el-image :src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
                                            <div slot="error" class="image-slot">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                    </el-col>
                                    <el-col :span="15" class="order_Info_item">
                                        <!-- <p>{{item.proTitle}}</p>  {{item.specificationlist[0].name}}-->
                                        <p>{{goodsItem.name}}  <span style="color:#78b942">{{goodsItem.specificationlist!=null && goodsItem.specificationlist.length>0?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span></p>
                                        <p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
                                    </el-col>

                                </el-row>
                            </el-col>
                            <el-col :span="4">
                                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
                                <!-- <el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger" @click="payOrderNow(item.amount,item)">立即支付</el-button>
                                <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button>
                                <el-button v-if="item.status==5?false:true" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button> -->
                                <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(item.oid)">移出订单</el-button>
                                <el-button v-if="item.orderType == 5" class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
                                <el-button class="buttonStyle" plain @click="down(item.oid)">导出订单</el-button>

                            </el-col>
                        </el-row>
                   </div>
                    <div class="noData" v-if="orderInfoList.length==0?true:false">
                            您还没有相关订单。
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="35" label="待上传凭证">
              <!-- <span slot="label">待支付</span> -->
              <span slot="label">待上传凭证</span>
              <div  class="tab_pane_content">
                <div class="search_box">
                  <div class="div-left"></div>
                  <div class="div-right">
                  <el-input placeholder="请输入订单标题/订单号" v-model="waitpayValue" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchHandle(waitpayValue)"></el-button>
                  </el-input>
                  </div>
                </div>
                <div v-for="(item,index) in orderInfoList" :key="index" :class="item.status==35?'orderbox_info redBorder':'orderbox_info'">
                  <div class="orderbox_info_header">
                    <div style="width:80%">
                      <p>{{orderStatus(item.status)}}</p>
                      <p>{{item.commodityName}}</p>
                      <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                      <span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider direction="vertical"></el-divider>
                      <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                    </div>
                    <div>
                      <span class="order_money">订单金额：<i >{{item.totalMoney || 0.00}}</i> 元</span>
                    </div>
                  </div>
                  <el-row class="order_goods_whole">
                    <el-col :span="20" @click.native="gotoDetail(item)">
                      <el-row class="order_goods"  v-for="(goodsItem,index) in item.bxyCommodityList" :key="index">
                        <el-col :span="2">
                          <!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
                          <el-image :src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                        </el-col>
                        <el-col :span="15" class="order_Info_item">
                          <!-- <p>{{item.proTitle}}</p>{{item.specificationlist[0].name}}-->
                          <p>{{goodsItem.name}}  <span style="color:#78b942">{{goodsItem.specificationlist!=null && goodsItem.specificationlist.length>0?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span></p>
                          <p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
                          <!-- <p>{{(item.price!=null && item.price!="")?item.price: item.marketprice}} * {{item.number || 1 }}</p> -->
                        </el-col>

                      </el-row>
                    </el-col>
                    <el-col :span="4">
                      <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
                      <el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger" @click="payOrderNow(item.amount,item)">立即支付</el-button>
                      <el-button v-if="item.status==35" class="buttonStyle dangerBg" type="danger" @click="paymentVoucher(item)">上传凭证</el-button>
                      <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button>
                      <el-button v-if="item.status==1 || item.status==35" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button>
                      <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(item.oid)">移出订单</el-button>
                      <el-button class="buttonStyle" @click="down(item.oid)">导出订单</el-button>
                      <el-button v-if="item.orderType == 5" class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
                    </el-col>
                  </el-row>
                </div>

                <div class="noData" v-if="orderInfoList.length==0?true:false">
                  您还没有相关订单。
                </div>
              </div>
            </el-tab-pane>
        </el-tabs>
        <el-row>
          <el-col :span="24" class="pagination">
              <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </el-col>
        </el-row>
          <el-dialog title="上传支付凭证" :visible.sync="dialogFormVisible">
            <div style="width:600px;margin-bottom: 50px">
              <div style="display: flex;justify-content: space-between">
                <div>账户名称</div>
                <div>{{merchantBankInfo.corporateAccountName}}</div>
              </div>
              <div style="display: flex;justify-content: space-between">
                <div>开户银行</div>
                <div>{{merchantBankInfo.corporateBankName}}</div>
              </div>
              <div style="display: flex;justify-content: space-between">
                <div>银行卡号</div>
                <div>{{merchantBankInfo.corporateBankAccount}}</div>
              </div>
              <div style="display: flex;justify-content: space-between">
                <div>银行地址</div>
                <div>{{merchantBankInfo.corporateBankAddress}}</div>
              </div>
            </div>
            <el-form :model="payParams" :rules="rules" ref="ruleForm">
              <el-form-item label="支付凭证" prop="paymentVoucher" class="imgDiv">
                <el-upload
                  name="files"
                  class="avatar-uploader"
                  :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess">
                  <i class="el-icon-plus avatar-uploader-icon" style="width: 30px;height: 30px"></i>
                </el-upload>
                <img v-if="payParams.paymentVoucher" :src="payParams.paymentVoucher" class="avatar" style="width: 300px;">
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="onPaymentVoucherSubmit('ruleForm')">确 定</el-button>
            </div>
          </el-dialog>


          <!--  支付记录弹窗  -->
          <el-dialog title="支付记录" :visible.sync="dialogVisible" width="1338px">
            <el-table :data="payLogList" style="width: 100%;" border  show-summary :summary-method="getSummariesPayAmount">
              <el-table-column property="merOrderNo" label="支付单号" width="290" header-align="center" align="center"></el-table-column>
              <el-table-column property="amount" label="金额" width="170" header-align="center" align="center"></el-table-column>
              <el-table-column property="payAmount" label="支付金额" width="170" header-align="center" align="center"></el-table-column>
              <el-table-column property="payStatus" label="支付状态" header-align="center" align="center"
                               :filters="payStatusFilters"
                               :filter-method="filterPayStatus">
                <template slot-scope="scope">
                  <el-tag
                    :type="getStatusType(scope.row.payStatus)"
                    disable-transitions> {{ getStatusText(scope.row.payStatus) }}</el-tag>

                </template>
              </el-table-column>
              <el-table-column property="payTime" label="支付日期" width="170" header-align="center" align="center"></el-table-column>
              <el-table-column label="支付人" width="150" header-align="center" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.currentMerName">{{ scope.row.currentMerName }}</span>
                  <span v-else-if="scope.row.nickname">{{ scope.row.nickname }}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column property="createTime" label="创建日期" width="166" header-align="center" align="center"></el-table-column>
              <el-table-column property="payStatus"  label="操作" width="90" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.payStatus === 0"  size="small" type="success" @click="checkPaymentStatus(scope.row.merOrderNo, false)">已支付</el-button>
                </template>
              </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialog()" class="buttonBgd">确 定</el-button>
      </span>
          </el-dialog>

        </div>


</template>
<script>
  import { offlinePayment } from "@/api/dealerSettled";
import Pagination from '@/components/Pagination'
import {downloadDevices} from '@/api/excel'
import {searchOrder,showorderList,cancleOrderItem,removeOrderItem,payStatus,xy_personvalue,confirmRceiptItem, payOrderList, cloudBillOrderPayQueryV2} from '@/api/xunyou'
 import {mapState,mapMutations} from "vuex";
export default {

  data() {
    return {
      mergeButton:1,
      orderNum:0,
      orderPrice:0,
      totalOrderNosMerge:[],
      totalOrderNos:[],
      searchBarFixed: true, // 监听滚动条
      merchantBankInfo: {},
      list:[],
      isDealer:false,
      indeterminate :false,
      checkAll :false,
      checkAllT:true,
      checkAllTwo :false,
      checkedCities:[], // 绑定默认选中
      isIndeterminate:false, // 设置 indeterminate 状态，只负责样式控制
      checkedOrderIds:[], // 绑定默认选中
      checkedOrderIdsTwo:[], // 绑定默认选中
      isIndeterminateTwo:false, // 设置 indeterminate 状态，只负责样式控制
      cities: [
        {
          "name":"高一",
          "value":"928"
        },
        {
          "name":"高二",
          "value":"929"
        },
        {
          "name":"高三",
          "value":"930"
        }
      ],

      rules: {
        paymentVoucher: [
          { required: true, message: '请上传支付凭证', trigger: 'change' }
        ]
      },
        payParams:{
          uid: JSON.parse(localStorage.getItem("userdata")).userId,
          oid: '',
          paymentVoucher: ''
        },
        dialogFormVisible:false,
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        loading:false,
        activeName:0,
        searchValue:'',
        orderInfoList:[],
        closeValue:'',
        finishiValue:'',
        waitGetValue:'',
        waitSendValue:'',
        waitpayValue:'',
        allValue:'',
         // 请求数据参数
        formInline: {
            pageSize: 10,
            pageNum: 1,
            status:0,
            title:'',
          auctionType: 1,
            muid:JSON.parse(localStorage.getItem("userdata")).userId,
        },
        // 分页参数
        pageparm:{
            pageSize:10,
            currentPage:1,
            total:0,
        },
        downUrl: '/portal/pc/export',
      dialogVisible: false,
      payLogList: [], // 支付记录列表
      payStatusFilters: [
        { text: '未支付', value: 0 },
        // { text: '未支付', value: 1 },
        { text: '已支付', value: 2 }
      ],
    };
  },
      // 注册组件
  components: {Pagination},
  computed: {
    ...mapState(["totalOrderPrice","totalOrderNum",'isTotalSelect']),
    ...mapMutations(["getTotalOrderPrice","getTotalOrderNum","getIsTotalSelect","getIsTotalDisplay"])
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */


  created() {
    if (this.userInfo.roleId == 10){ //经销商
      this.isDealer = true
    }
  },
  mounted(){
      if(this.$route.fullPath.indexOf('tap')>0){
          this.activeName =this.$route.query.tap
      }

      if(this.$route.fullPath.indexOf('orderNumer')>0){
          this.getPayStatus()
        //   this.getshoworderList(this.activeName)
      }else{
          this.getshoworderList(this.activeName)
      }
  },
  watch: {
    '$store.state.isTotalSelect'() {
      console.log('isTotalSelect change!'+this.isTotalSelect);
      this.checkAll=this.isTotalSelect;
      this.handleCheckAllChangeOne(this.isTotalSelect);
      this.checkAllTwo=this.isTotalSelect;
      this.handleCheckAllChangeTwo(this.isTotalSelect);
    }
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    down(id){
      const params  = {oid:id}
      downloadDevices('GET',this.downUrl+"/"+id,params).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/xlsx' }))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', 'saleOrder.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) // 下载完成移除元素
        window.URL.revokeObjectURL(url) // 释放掉blob对象
      })
    },
    // 全选 --- 当绑定值变化时触发的事件
    handleCheckAllChange(val) {
      console.log(val) // val的值是一个布尔值，点中全选为false，取消全选为true
      this.cities.forEach(item=>{ // 当全选被选中的时候，循环遍历源数据，把数据的每一项加入到默认选中的数组去
        this.checkedCities.push(item.name)
      })
      this.checkedCities = val ? this.checkedCities : []; // 三元表达式，如果val的值为true，那么就把当前默认选中的值赋值给自身，这样页面页面上所有的元素就都选中了。如果为false，就是取消全选
      this.isIndeterminate = false;  // 官网说这是个样式控制，是来控制，什么时候半选的，要不要都无所谓，看你需求
    },

    // checkbox选中 --- 当绑定值变化时触发的事件
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;   //选中值的长度
      this.checkAll = checkedCount === this.cities.length;  // 如果选中值的长度和源数据的长度一样，返回true，就表示你已经选中了全部checkbox，那么就把true赋值给this.checkAll
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length; // 同全选按钮事件里面的那个样式控制
    },

    // 全选 --- 当绑定值变化时触发的事件
    handleCheckAllChangeOne(val) {
      console.log("handleCheckAllChangeOne"+val) // val的值是一个布尔值，点中全选为false，取消全选为true
      this.orderPrice=0;
      this.orderNum=0;
      this.totalOrderNosMerge=[];
      if(val){
        this.orderInfoList.forEach(item=>{ // 当全选被选中的时候，循环遍历源数据，把数据的每一项加入到默认选中的数组去
          if(item.status==1){
            item.check="true";
            this.checkedOrderIds.push(item.oid);
            this.totalOrderNosMerge.push(item.totalOrderNumber);
            this.orderNum++;
            this.orderPrice=this.orderPrice+item.orderAmount;
          }
        });
      }
      if(val){
        this.$store.commit("getIsTotalSelect", true);
      }else{
        this.$store.commit("getIsTotalSelect", false);
      }
      //全局变量变化
      this.$store.commit("getTotalOrderPrice", this.orderPrice);
      this.$store.commit("getTotalOrderNum", this.orderNum);
      //this.totalOrderPrice=this.orderPrice;
      console.log("1-----1----orderPrice="+this.orderPrice);
      console.log("orderNum="+this.orderNum);
      sessionStorage.setItem("mergeFlag", JSON.stringify("true"));
      sessionStorage.setItem("account", JSON.stringify(this.orderPrice));
      sessionStorage.setItem("orderNum", JSON.stringify(this.orderNum));
      sessionStorage.setItem("totalOrderNosMerge", JSON.stringify(this.totalOrderNosMerge));
      this.checkedOrderIds = val ? this.checkedOrderIds : []; // 三元表达式，如果val的值为true，那么就把当前默认选中的值赋值给自身，这样页面页面上所有的元素就都选中了。如果为false，就是取消全选
      this.isIndeterminate = false;  // 官网说这是个样式控制，是来控制，什么时候半选的，要不要都无所谓，看你需求

    },

    // 全选 --- 当绑定值变化时触发的事件
    handleCheckAllChangeTwo(val) {
      console.log(val) // val的值是一个布尔值，点中全选为false，取消全选为true
      this.orderPrice=0;
      this.orderNum=0;
      this.totalOrderNosMerge=[];
      if(val){
        this.orderInfoList.forEach(item=>{ // 当全选被选中的时候，循环遍历源数据，把数据的每一项加入到默认选中的数组去
          if(item.status==1){
            item.check="true";
            this.checkedOrderIdsTwo.push(item.oid);
            this.totalOrderNosMerge.push(item.totalOrderNumber);
            this.orderNum++;
            this.orderPrice=this.orderPrice+item.orderAmount;
          }
        });
      }
      if(val){
        this.$store.commit("getIsTotalSelect", true);
      }else{
        this.$store.commit("getIsTotalSelect", false);
      }
      //全局变量变化
      this.$store.commit("getTotalOrderPrice", this.orderPrice);
      this.$store.commit("getTotalOrderNum", this.orderNum);
      //this.totalOrderPrice=this.orderPrice;
      console.log("1-----1----orderPrice="+this.orderPrice);
      console.log("orderNum="+this.orderNum);
      sessionStorage.setItem("mergeFlag", JSON.stringify("true"));
      sessionStorage.setItem("account", JSON.stringify(this.orderPrice));
      sessionStorage.setItem("orderNum", JSON.stringify(this.orderNum));
      sessionStorage.setItem("totalOrderNosMerge", JSON.stringify(this.totalOrderNosMerge));
      this.checkedOrderIdsTwo = val ? this.checkedOrderIdsTwo : []; // 三元表达式，如果val的值为true，那么就把当前默认选中的值赋值给自身，这样页面页面上所有的元素就都选中了。如果为false，就是取消全选
      this.isIndeterminateTwo = false;  // 官网说这是个样式控制，是来控制，什么时候半选的，要不要都无所谓，看你需求

    },

    // checkbox选中 --- 当绑定值变化时触发的事件
    handlecheckedOrderIdTwoChange(value) {
      let checkedCount = value.length;   //选中值的长度
      this.checkAllTwo = checkedCount === this.orderInfoList.filter(e=>e.status==1).length;  // 如果选中值的长度和源数据的长度一样，返回true，就表示你已经选中了全部checkbox，那么就把true赋值给this.checkAll
      this.isIndeterminateTwo = checkedCount > 0 && checkedCount < this.orderInfoList.filter(e=>e.status==1).length; // 同全选按钮事件里面的那个样式控制
    },

    // checkbox选中 --- 当绑定值变化时触发的事件
    handlecheckedOrderIdChange(value) {
      let checkedCount = value.length;   //选中值的长度
      this.checkAll = checkedCount === this.orderInfoList.filter(e=>e.status==1).length;  // 如果选中值的长度和源数据的长度一样，返回true，就表示你已经选中了全部checkbox，那么就把true赋值给this.checkAll
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.orderInfoList.filter(e=>e.status==1).length; // 同全选按钮事件里面的那个样式控制
    },

    handleCheckedCountryChange(index, item,totalOrderNumber,orderAmount, e) {
      console.log("orderAmount",orderAmount);
      if(e==true){
        item.check="true";
        this.totalOrderNosMerge.push(totalOrderNumber);
        this.orderPrice=this.orderPrice+orderAmount;
        this.orderNum++;
        this.mergeButton=0;
      }else if(e==false){
        item.check="false";
        this.orderNum--;
        this.orderPrice=this.orderPrice-orderAmount;
        this.totalOrderNosMerge = this.totalOrderNosMerge.filter(t => t != totalOrderNumber);
        if(this.orderNum==0){
          this.mergeButton=1;
        }
      }
      //全局变量变化
      this.$store.commit("getTotalOrderPrice", this.orderPrice);
      this.$store.commit("getTotalOrderNum", this.orderNum);
      //this.totalOrderPrice=this.orderPrice;
      console.log("totalOrderPrice="+this.totalOrderPrice);
      sessionStorage.setItem("mergeFlag", JSON.stringify("true"));
      sessionStorage.setItem("account", JSON.stringify(this.orderPrice));
      sessionStorage.setItem("orderNum", JSON.stringify(this.orderNum));
      sessionStorage.setItem("totalOrderNosMerge", JSON.stringify(this.totalOrderNosMerge));
      console.log(e);

    },
    // 总计
    submitForm() {
      if(this.totalOrderNosMerge.length<2){
        this.$message.error('请选中俩条订单以上订单！')
        return;
      }
      this.$router.push('/orderNow')
    },
      // 选择状态判断
    status() {
      let allProduct = 0;
      let selectProduct = 0;
      this.list.forEach((x) => {
        if (x && x.goods.length) {
          allProduct= allProduct + x.goods.length;
          x.goods.forEach((items) => {
            if (items.checked) {
              //  this.addPriceSelectList.length>0? this.addPriceSelectList.forEach((item)=>{ //collectAddPriceList
              this.collectAddPriceList.length>0? this.collectAddPriceList.forEach((item)=>{ //collectAddPriceList
                selectProduct+= 1;
              }):''
              selectProduct += 1;
            }
            allProduct+=(items.bxyCarPromotion!=null?items.bxyCarPromotion.addfeegoods.length:0)
          });
        }
      });
      let isSelect = selectProduct === 0;
      return [allProduct, selectProduct, isSelect];
    },
    paymentVoucher(row) {
      console.log('row:',row)
      this.merchantBankInfo = row.bxunyouMerchant;
      this.payParams.oid = row.oid;
      this.dialogFormVisible = true
    },
    onPaymentVoucherSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          offlinePayment(this.payParams).then(res => {
            if (res.code == 0){
              this.$message.success(res.msg);
              this.getshoworderList(this.activeName);
              this.dialogFormVisible = false
            }else {
              this.$message.success(res.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.payParams.paymentVoucher = res.url
    },
      // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getshoworderList(this.activeName)
    },
      // // 查询支付状态
      getPayStatus() {
         payStatus({
             out_trade_no: this.$route.query.orderNumer
         })
            .then(res => {
                // console.log('res路径',res,res.alipay_trade_query_response.code==10000 , res.alipay_trade_query_response.trade_status=='TRADE_SUCCESS')
                if(res.alipay_trade_query_response.code==10000 && res.alipay_trade_query_response.trade_status=='TRADE_SUCCESS'){
                    // console.log('杨老板接口进来了吗')
                   xy_personvalue({
                        orderId:this.$route.query.orderNumer   // 这个需要处理重新获值
                    })
                        .then(res => {
                            // console.log(res,'杨老板接口进来了吗')
                            this.getshoworderList(this.activeName)
                            // this.$message.error('调取失败失败，请稍后再试！')
                        })
                        .catch(err => {
                        this.$message.error('查询失败，请稍后再试！')
                        })
                }
            })
            .catch(err => {

            })
    },
    //   切换tab
      tabhandleClick(tab, event) {
        // getshoworderList
        this.totalOrderNosMerge=[];
        this.orderNum=0;
        this.orderPrice=0;
        this.checkAll=false;
        this.isIndeterminate=false;
        this.checkAllTwo=false;
        this.isIndeterminateTwo=false;
        this.checkedOrderIds=[];
        this.checkedOrderIdsTwo=[];
        //全局变量变化
        this.$store.commit("getTotalOrderPrice", this.orderPrice);
        this.$store.commit("getTotalOrderNum", this.orderNum);
        this.$store.commit("getIsTotalSelect", false);
        console.log(this.activeName,tab, event,'tab切换');
        if(this.activeName==0 || this.activeName==1){
          this.$store.commit("getIsTotalDisplay", true);
        }else{
          this.$store.commit("getIsTotalDisplay", false);
        }
        this.getshoworderList(this.activeName)
    //    this.getshoworderList(1);
      },

    // 订单查询
     getshoworderList(status,value){
         this.loading =true
         this.formInline.status = status==0?'':status
         this.formInline.title = value || '';
        //  status = status==0?'':status
        //     {
        //     status:status,
        //     title:value || '',
        //     muid:this.userInfo.userId,
        // }
        showorderList(this.formInline)
            .then(res => {
              if (res.code == 0) {
                  this.loading = false
                  this.orderInfoList = res.rows
                  this.orderInfoList.forEach((item)=>{
                     item.totalMoney = (Number(item.amount)+Number(item.transportfee)).toFixed(2);
                     item.check=true;
                  })
                  console.log( this.orderInfoList ,'ccc123');
                    // 分页赋值
                this.pageparm.currentPage = this.formInline.pageNum
                this.pageparm.pageSize = this.formInline.pageSize
                this.pageparm.total = res.total
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('查询红包失败，请稍后再试！')
            })
      },

    //   订单状态转换
    orderStatus(status){
        switch(status) {
            case 1:
                return '等待买家付款'
                break;
            case 2:
                 return '等待卖家发货'
                break;
            case 3:
                 return '等待买家确认收货'
                break;
            case 4:
                 return '交易成功'
                break;
            case 5:
                 return '交易关闭'
                break;
            // case 11:
            //      return '买家提交退单'
            //     break;
            // case 12:
            //      return '退单审核中'
            //     break;
            // case 13:
            //      return '等待卖家收货确认'
            //     break;
            // case 14:
            //      return '等待卖家退款确认'
            //     break;
            // case 15:
            //      return '等待买家收款确认'
            //     break;
            case 16:
                 return '退款完成'
                break;
            // case 17:
            //      return '已拒绝退款'
            //     break;
            // case 18:
            //      return '已取消'
            //     break;
          case 35:
            return '等待上传支付凭证'
            break;
          case 33:
            return '等待店铺审核支付凭证'
            break;
          case 34:
            return '店铺审核失败'
            break;
            default:
                return '--'
        }
    },

    // 搜索功能
    searchHandle(value){
        this.getshoworderList(this.activeName,value)
    },

// 确认收货
    confirmRceipt(item){
        confirmRceiptItem({oid:item.oid,orderNumber:item.orderNumber}).then(res => {
              if (res.code == 0) {
                this.$message({
                    type: 'success',
                    message: '确认收货成功!'
                });
                 this.getshoworderList(this.activeName)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('确认收货失败，请稍后再试！')
            })
    },

    // 订单详情
    gotoDetail(item){
        console.log(item,'订单详情')
        sessionStorage.setItem("orderDetail", JSON.stringify(item));
        if(item.orderType && item.orderType === 5) {
          this.$router.push('/myOrderDetailCMB')
        } else {
          this.$router.push('/myOrderDetail')
        }

   },

    // 立即支付
    payOrderNow(amount,orderGoodsInfo){
        this.totalOrderNos=[];
        this.totalOrderNos.push(orderGoodsInfo.totalOrderNumber);
        sessionStorage.setItem("account", JSON.stringify(Number(amount)+Number(orderGoodsInfo.transportfee)));
        orderGoodsInfo.title = orderGoodsInfo.commodityName
        orderGoodsInfo.amount = Number(amount)+Number(orderGoodsInfo.transportfee)
        sessionStorage.setItem("unPayMoney", JSON.stringify(Number(orderGoodsInfo.amount)-Number(orderGoodsInfo.paidAmount)));
        sessionStorage.setItem("orderGoodsInfo", JSON.stringify([orderGoodsInfo]));
        //判断是否是合并支付
        sessionStorage.setItem("mergeFlag", JSON.stringify("false"))
        sessionStorage.setItem("totalOrderNos", JSON.stringify(this.totalOrderNos));

        this.$router.push('/orderNow')
    },

    //   取消订单
     cancleOrder(orderId) {
        this.$confirm('确定取消订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
             cancleOrderItem({oid:orderId}).then(res => {
              if (res.code == 0) {
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
                 this.getshoworderList(this.activeName)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询红包失败，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },

    // 订单评价
    orderEvaluation(item){
         this.$router.push(`/orderAppraisal?orderNumber=${item.orderNumber}`)
        //  $router.push(`/gotoEvaluation?orderNumber=${item.orderNumber}`)
    },

    //   移出订单
    removeOrder(orderId){
        this.$confirm('确定移除订单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           removeOrderItem({oid:orderId}).then(res => {
              if (res.code == 0) {
                this.$message({
                    type: 'success',
                    message: '移除成功!'
                });
                 this.getshoworderList(this.activeName)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('移除失败，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已移除'
          });
        });
    },

   nextEditResource(){
       this.$refs.sizeForm.validate((valid) => {
          if (valid) {
            if(this.sizeForm.checkedBox){
                this.errerInfo=false;
                this.$router.push(`/merchantForm?type=${this.$route.query.type}`)
            }else{
                this.errerInfo=true;
            }
          }
        });
   },
    getStatusType(payStatus) {
      switch (payStatus) {
        case 0:
          return 'info'; // 你可以根据需要选择合适的类型
        case 2:
          return 'success';
        // 其他状态处理
        default:
          return 'info';
      }
    },
    // 支付记录状态
    getStatusText(status) {
      switch(status) {
        // case 1:
        //   return '未支付'
        //   break;
        case 2:
          return '已支付'
          break;
        default:
          return '未支付'
      }
    },
    // 弹窗展示支付记录
    showPayLog(item) {
      this.dialogVisible = true;
      this.getPayLog(item);
      this.orderItem = item
    },
    closeDialog() {
      this.dialogVisible = false;
      this.orderItem = {}
    },
    // 获取支付记录
    getPayLog(item){
      console.log('item.orderNumber', item.orderNumber)
      payOrderList({orderNumber: item.orderNumber})
        .then(res => {
          if (res.code === 0) {
            this.loading = false
            this.payLogList = res.data;
          } else {
            console.error('orderLogList fail', res.msg)
          }
        })
        .catch(err => {
          console.log('orderLogList fail', err)
        })
    },
    filterPayStatus(value, row) {
      return row.payStatus === value;
    },
    // 合计支付弹窗的支付金额
    getSummariesPayAmount(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property === 'payAmount') {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = `${parseFloat(sums[index].toFixed(2))} 元`;
          } else {
            sums[index] = '';
          }
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    checkPaymentStatus(merOrderNo, isAuto) {
      console.log('merOrderNo', merOrderNo)
      cloudBillOrderPayQueryV2({ merOrderNo:  merOrderNo  })
        .then(response => {
          console.log('response', response)
          if (response.code === 0) {
            this.$message.success('查询成功');
            if(isAuto) {
              this.refreshPage();
            }else {
              this.getPayLog(this.orderItem);
            }
          } else {
            this.$message.error('查询失败: ' + response.msg);
            this.refreshPage();
          }
        })
        .catch(error => {
          console.error('验证支付状态失败:', error);
          this.refreshPage();
        })
        .finally(() => {
            this.removeMerOrderNoAndRefresh();
          }
        );
    },

  },
};
</script>

<style scoped lang="less">


// .rightaside{
//     background: white;
//     margin-left: 15px;
//     padding: 20px !important;
    .rightaside_content{
        .headerTitle{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
        }
        /deep/.el-tabs--border-card{
            border: 0px;
            box-shadow: unset;
            .el-tabs__header{
                border-bottom: 0px;
                background: white;
               /deep/ .el-tabs__item.is-active {
                    color:  #78b942;
                    background-color: transparent;
                    border-right-color: transparent;
                    border-left-color: transparent;
                }
            }
        }
        .search_box {
            text-align: left;
            margin-bottom: 10px;
            display: flex;
            .input-with-select.el-input.el-input-group.el-input-group--append {
            }
            .el-checkbox{
              width: 50%;
              text-align: left;
            }
            .el-checkbox-all{
              width: 10%;
              text-align: left;
            }
            .div-left{
              display: inline-block;
              width: 50%;
            }
            .div-right{
              display: inline-block;
              width: 50%;
              //border: 1px solid red;
              //text-align: right;

            }
        }
        .redBorder {
            border: 1px solid #78b942 !important;
        }
        .orderbox_info {
            // padding: 20px;
            // box-sizing: border-box;
            margin-bottom: 10px;
             border: 1px solid#ccc;
            .orderbox_info_header {
                padding: 20px;
                box-sizing: border-box;
                border-bottom: 1px solid #ccc;
                display: flex;
                justify-content: space-between;
                p{
                    font-size: 16px;
                    color: #78b942;
                    margin-bottom: 5px;
                }
                .order_money i{
                    font-size: 20px;
                    color: #78b942;
                }
            }
            .order_goods_whole {
                padding: 20px;
                box-sizing: border-box;
                .order_goods {
                    margin-bottom: 20px;
                    .order_Info_item {
                        margin-left: 20px;
                    }
                }
                button.el-button.buttonStyle {
                    padding: 6px 30px;
                    font-size: 12px;
                    margin-bottom: 6px;
                    margin-left: 0;
                }
                .buttonStyleMerge {
                  padding: 6px 10px;
                  font-size: 12px;
                  margin-bottom: 6px;
                  margin-left: 0;
                }
                .dangerBg.buttonStyle{
                    background-color:  #78b942;
                    border-color:  #78b942;
                }
                .el-button--danger.is-plain{
                    background: white;
                }
                .el-button--danger:focus, .el-button--danger:hover{
                    color: white;
                    background: #78b942;
                }
            }
        }
        .tab_pane_content{
            .noData{
                text-align: center;
                height: 200px;
                line-height: 200px;
            }
        }

    }
// }
.pagination{
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #78b942;
      color: #FFF;
      width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
      background-color: transparent;
  }
}

.checkBoxLable{
    font-size: 16px;
    color: #78b942;
    margin-bottom: 5px;
}
.pOne{
  text-align: left;
  height: 20px;
  line-height: 20px;
  font-size: 20px;
  font-weight:bold;
}

.buttonOne{
  float: right;
}
.font-size {
  position: relative;
  left: -60px;
  top: 1px;
  height: 12px;
  display: block;
  font-size: 12px;
  transform: scale(0.8);

}

</style>







// WEBPACK FOOTER //
// src/views/myOrder/myOrder.vue